<script lang="ts" setup>
import { ref, computed } from 'vue'
import {SparklesIcon,ArrowRightIcon} from "@heroicons/vue/24/outline";
import Button from "@src/components/ui/inputs/Button.vue";
import SuggestionMessages from "@src/services/suggestionMessages";
import {useMessageStore} from "@src/stores/messages";

const messageStore = useMessageStore()

const emit = defineEmits(['closeModal'])

const loading = ref<boolean>(false)

const errorText = ref<boolean>(false)

const errorApi = ref<boolean>(false)

const responseMessage = ref('')

const confirm_button = ref<boolean>(false);

const selectedOption = ref('fix')

const selectBgClass = computed(() => {
        switch (selectedOption.value) {
            case 'fix':
                return 'bg-green-600'
            case 'formalize':
                return 'bg-blue-400'
            case 'friendly':
                return 'bg-amber-600'
            default:
                return 'bg-green-500'
        }
    })

const submit = async () => {
    loading.value = true

    const response = await SuggestionMessages.submit(
        messageStore.message,
        selectedOption.value
    )

    loading.value = false

    if (response !== 'error' && response !== 'error_api') {
        confirm_button.value = true
        responseMessage.value = response
        errorText.value = false
        errorApi.value = false
        return
    }

    if( response === 'error'){
        confirm_button.value = false
        errorText.value = true
        errorApi.value = false
        return
    }

    if( response === 'error_api'){
        confirm_button.value = false
        errorText.value = false
        errorApi.value = true
    }
}

const confirmMessage = async () => {
    messageStore.message = responseMessage.value
    emit('closeModal')
}
</script>
<template>
    <div class="fixed z-50 inset-0 overflow-y-auto" role="dialog" @click.stop>
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 backdrop-blur-[2px]">
            <div class="fixed inset-0 opacity-25 bg-gray-500 dark:bg-gray-400 transition-opacity"
                 @click="$emit('closeModal')"></div>
            <div
                class="inline-block z-20 bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-3xl">
                <div class="p-4 min-w-120 max-w-160 bg-white dark:bg-gray-800 shadow-2xl dark:shadow-gray-800">
                    <div class="sm:flex sm:items-start px-3">
                        <div class="mt-3 text-center sm:mt-0 w-full sm:text-left">
                            <div class="flex flex-row mb-6">
                                <SparklesIcon class="w-6 h-6 mr-3 text-gray-900 dark:text-gray-100"/>
                                <h3 class="text-lg leading-6 text-gray-900 dark:text-gray-100">
                                    Sugestão de mensagem com I.A
                                </h3>
                            </div>
                        </div>

                        <div class="w-full">
                            <h3 class="leading-6 font-bold text-gray-700 mt-1 dark:text-gray-100">
                                Escolher ação:
                            </h3>
                            <div class="flex mt-3">
                                <select
                                    v-model="selectedOption"
                                    :class="['w-full font-semibold text-white rounded-sm px-3 p-3',selectBgClass]"
                                >
                                    <option class="bg-gray-400 text-white" value="fix">
                                        ✔   Corrigir erros ortográficos
                                    </option>

                                    <option class="bg-gray-400 text-white" value="formalize">
                                        ✉ ︎Formalizar Mensagem
                                    </option>

                                    <option class="bg-gray-400 text-white flex items-center" value="friendly">
                                        ☻ Humanizar Mensagem
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="w-full mt-3">
                            <h3 class="leading-6 font-bold text-gray-700 dark:text-gray-100">
                                Mensagem original:
                            </h3>
                            <textarea v-model="messageStore.message" class="bg-gray-200 w-full rounded-sm mt-3 p-4 min-h-8"></textarea>
                        </div>


                        <div v-if="errorApi || errorText || confirm_button" class="w-full mt-4">
                            <div v-if="confirm_button" class="w-full">
                                <h3 class="leading-6 font-bold text-gray-700 dark:text-gray-100">
                                    Mensagem melhorada:
                                </h3>
                                <div class="bg-brand-400 w-full rounded-sm mt-3 p-4 min-h-8 text-white max-h-40 overflow-y-auto">
                                    {{ responseMessage }}
                                </div>
                            </div>

                            <div v-if="errorApi || errorText" class="bg-yellow-300 w-full rounded-sm mt-3 p-4 min-h-8 max-h-40 overflow-y-auto">
                                <span v-if="errorText"> Não foi possível entender sua mensagem, <br> Por favor tente digitá-la novamente.</span>
                                <span v-if="errorApi"> Chave API inválida, cadastre uma chave API válida.</span>
                            </div>
                        </div>

                        <div class="w-full mt-4 flex justify-between">
                            <button @click="$emit('closeModal')"  class="disabled:opacity-25 cursor-pointer disabled:cursor-auto text-sm justify-center rounded-md bg-gray-400 text-white hover:bg-gray-500 dark:bg-gray-700 dark:hover:bg-gray-600 p-3 px-5 font-bold">
                                Fechar
                            </button>

                            <div class="flex">
                                <Button :loading="loading" @click="submit" class="flex items-center disabled:opacity-25 cursor-pointer disabled:cursor-auto text-sm justify-center rounded-md bg-brand-500 text-white hover:bg-brand-700 dark:bg-brand-700 dark:hover:bg-brand-800 p-3 px-5 font-bold">
                                    Gerar mensagem
                                    <sparkles-icon class="h-5 w-5 ml-3"></sparkles-icon>
                                </Button>
                                <button @click="confirmMessage"  v-if="confirm_button" class="flex items-center disabled:opacity-25 ml-4 cursor-pointer disabled:cursor-auto text-sm justify-center rounded-md bg-green-600 text-white hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-800 p-3 px-5 font-bold">
                                    Usar mensagem
                                    <arrow-right-icon class="h-5 w-5 ml-3"></arrow-right-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>